// DS: CR28
import React, { useCallback, useRef, useMemo, useContext, } from 'react';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { NCContext } from '@wix/da-react-context/pkg/NCContext';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import noop from '../../../utils/noop';
import SiteHeaderStyles from '../SiteHeaderDesktop.scss';
import s from './NotificationsDropdownWrapper.scss';
var NotificationsDropdownWrapper = function (_a) {
    var feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onMouseEnter = _a.onMouseEnter, onTouchEnd = _a.onTouchEnd, biData = _a.biData, isLegacyHeader = _a.isLegacyHeader, isFeedbackPageOpen = _a.isFeedbackPageOpen, _b = _a.onMouseLeave, onMouseLeave = _b === void 0 ? noop : _b, toggleFeedbackPage = _a.toggleFeedbackPage, toggleBurgerMenu = _a.toggleBurgerMenu, ariaLabel = _a["aria-label"];
    var t = useTranslation().t;
    var _c = useContext(NCContext), DrawerComponent = _c.DrawerComponent, isStandalonePage = _c.isStandalonePage;
    var ftueEnabled = Boolean(feedbackCount && feedbackCount !== '0');
    // no point to spamming this if our guest has twitchy hands
    var throttledMouseLeave = useMemo(function () { return throttle(onMouseLeave, 300); }, [onMouseLeave]);
    var rootRef = useRef(null);
    var onClose = useCallback(function (event) {
        if (event === void 0) { event = {}; }
        throttledMouseLeave(event);
    }, [throttledMouseLeave]);
    var handleClickOutside = useCallback(function () {
        if (!isOpen) {
            return;
        }
        onClose();
    }, [isOpen, onClose]);
    useOnOutsideClick(rootRef, handleClickOutside);
    var handleIconClick = useCallback(function (e) {
        if (isLegacyHeader) {
            window.location.assign(Url.feedbackLink());
            return;
        }
        if (!isStandalonePage) {
            toggleBurgerMenu(false); // Close network bar, if it's open
            toggleFeedbackPage();
        }
        // We put an `href` attribute on the element that calls this so users can open notifications in a new tab,
        // so we prevent default to avoid the standard handling of an anchor tag click since we're duper browsing.
        e.preventDefault();
    }, [isStandalonePage, isLegacyHeader, toggleFeedbackPage, toggleBurgerMenu]);
    return (React.createElement("div", { className: classnames(SiteHeaderStyles['icon-button-has-submenu'], SiteHeaderStyles['icon-button-has-notifications-submenu']), onMouseEnter: function (e) {
            if (!isFeedbackPageOpen && !isStandalonePage) {
                onMouseEnter(e);
            }
        }, onMouseLeave: function (e) {
            onClose(e);
        }, ref: rootRef },
        React.createElement(SophisticatedFtueTooltip, { heading: t('siteHeader.notificationsMenu.ftue.heading'), description: t('siteHeader.notificationsMenu.ftue.description'), size: "medium", placement: "bottom", width: 301, flag: FirstTimeFlag.IsNewNCHeaderNotAcknowledged, hasCloseButton: true, enabled: ftueEnabled },
            React.createElement(PlainButtonOrLink, { biData: biData, className: classnames(SiteHeaderStyles['icon-button'], isOpen && SiteHeaderStyles['toggled'], feedbackCount !== '0' && s['extra-margin-for-indicator']), "aria-label": ariaLabel, onClick: handleIconClick, 
                // This weird bit is to enable `right click > open in new tab`. We prevent default
                // in the onClick handler since we handle navigation ourself via duper browse.
                href: isStandalonePage || isFeedbackPageOpen
                    ? undefined
                    : Url.feedbackLink() },
                React.createElement("span", null,
                    React.createElement(NotificationIcon, { className: SiteHeaderStyles['notifications-icon'], size: IconSize.MEDIUM }),
                    feedbackCount !== '0' && (React.createElement("span", { className: SiteHeaderStyles['number'] }, feedbackCount))))),
        DrawerComponent && !isStandalonePage && (React.createElement("div", { role: "dialog", id: "site-header-notifications", className: s['notifications-dropdown-wrapper'] },
            React.createElement("div", { className: classnames(s['container'], isOpen && s['active']) }, isOpen && (React.createElement(DrawerComponent, { isDropdown: true, openFeedbackPage: function () {
                    return toggleFeedbackPage && toggleFeedbackPage();
                } })))))));
};
NotificationsDropdownWrapper.displayName = 'NotificationsDropdownWrapper';
export default NotificationsDropdownWrapper;
//# sourceMappingURL=NotificationsDropdownWrapper.js.map